import type { DetailListProps } from '@presentation/components/DetailList/types';

export interface DetailListScheduleData {
  times: string[][];
  // times[0] <- monday, times[1] <- tuesday, ...
  // times[0][0] = "08:00 - 12:00"
  // times[0][1] = "13:00 - 18:00"
}

export interface DetailListScheduleProps
  extends Omit<DetailListProps, 'items'>,
    DetailListScheduleData {}
